import { getBaseUrl } from "@/utils";
import axios from "axios";

export const axiosInstance = axios.create({
 baseURL: getBaseUrl(),
});
